var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "FlagGb",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 999 600"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path fill="#000066" d="M0 0h999v600H0V0z"/>
  <polygon fill="#FFFFFF" points="999,0 965.8,0 599.9,182.9 599.9,0 400,0 400,182.9 34.1,0 0,0 0,117.1 165.9,200 0,200.5 0,400.5	165.9,400 0,482.9 0,600 34.1,600 400,417.1 400,600 599.9,600 599.9,417.1 965.8,600 999,600 999,482.5 834,400 999,400 999,200	834,200 999,117.5"/>
  <polygon fill="#CC0000" points="560,0 440,0 440,240 0,240 0,360 440,360 440,600 560,600 560,360 999,360 999,240 560,240"/>
  <polygon fill="#CC0000" points="0,550.5 0,600 389.5,400 299.9,400"/>
  <polygon fill="#CC0000" points="298.9,200 0,50 0,94.8 209.5,200"/>
  <polygon fill="#CC0000" points="999,50.5 999,5.8 610.6,200 700,200"/>
  <polygon fill="#CC0000" points="700,400 999,549.5 999,504.8 789.4,400"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/flag-gb.svg